import NProgress from "nprogress";
import {
    resizeAllGridItems,
    checkGridAfterImagesLoaded
} from "../utilities/grid-utilities";

import lazyImages from "./lazy-images";

export default function() {
    (function($) {
        $(function() {
            $(".js-content").removeClass("hidden");

            lazyImages();

            $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').wrap(
                '<div class="video-embed" />'
            );

            // Grids
            window.onload = resizeAllGridItems();
            window.addEventListener("resize", resizeAllGridItems);

            checkGridAfterImagesLoaded();
        });
    })(jQuery);
}



// WEBPACK FOOTER //
// ./src/js/partials/content.js